/**
 * PURPOSE: Provide reducers that are not required for the initial bootstrap of the application.  For the bootstrap related reducers
 *   take a look at `initialReducers.ts`.
 */

// libraries
import type { InitContext } from '@makemydeal/dr-shared-store';
import { vehicleReducer } from '@makemydeal/dr-shared-store';
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import * as chooseVehicleReducer from './chooseVehicleReducer';
import * as dealerReducer from './dealerReducer';

// reducers
export type RemainingReducers = any;

/**
 * Retrieve reducers that aren't needed for the initial bootstrap of the application.  These reducers can be conditionally included
 * based on feature toggles etc.
 * @param context object that can provide additional context such as feature toggles
 * @returns object containing reducers
 */
export const getRemainingReducers = (context: InitContext): RemainingReducers => {
    const result: RemainingReducers = {
        changeVehicle: changeVehicleConfiguration.reducer,
        chooseVehicle: chooseVehicleReducer.reducer,
        dealer: dealerReducer.reducer,
        vehicle: vehicleReducer.reducer
    };

    return result;
};
